/* TGA-listed PDPs (Resveratrol v2, NMN + Resveratrol Kit v2). Apex v6 / NMN v2 layout, generalised from
   tapex-nmn.js (20 Oct 2026). Pack names, supply lines and days per pack come from data attributes, so the
   same script serves bottle and kit pages:
   - .tx-buybox: data-unit / data-units (e.g. Bottle / Bottles), data-kit-unit / data-kit-units,
     data-kit-handle (optional: kit product for the buy-box switch and the #tx-kit panel),
     data-kit-days (days of use per kit, for the kit panel).
   - .tx-row: data-days, data-line (supply line), data-kit-days, data-kit-line (when the kit switch is on).
   Savings vs buying separately are not shown (by request). */
(function(){
  var root = document.getElementById('tapex');
  if (!root) return;
  var box = root.querySelector('.tx-buybox');
  var rows = Array.prototype.slice.call(root.querySelectorAll('.tx-row'));
  var moreBtn = document.getElementById('tx-more');
  var kitBtn = document.getElementById('tx-upsell');
  var kitPrice = document.getElementById('tx-upsell-price');
  var variantInput = document.getElementById('tx-variant');
  var planInput = document.getElementById('tx-plan');
  var atc = document.getElementById('tx-atc');
  var qtyInput = document.getElementById('tx-qty');
  var form = document.getElementById('tx-form');
  var stickyBar = document.getElementById('tx-sticky');
  var stickyCta = document.getElementById('tx-sticky-cta');
  var stickySize = document.getElementById('tx-sticky-size');
  var stickyTitle = document.getElementById('tx-sticky-title');
  var shipLine = document.getElementById('tx-ship-line');
  var billLine = document.getElementById('tx-bill-line');
  var shipBase = shipLine ? shipLine.textContent : '';
  var modeBtns = root.querySelectorAll('[data-mode]');
  var attr = function(a, d){ var v = box.getAttribute(a); return v === null || v === '' ? d : v; };
  var FREE_SUB = parseInt(attr('data-ship-free-sub', '7500'),10) || 7500;
  var SUB_FEE = attr('data-ship-sub-fee', '');
  var NAME = attr('data-name', '');
  var KIT_NAME = attr('data-kit-name', 'Kit');
  var CTA = attr('data-cta', 'Add to Cart');
  var SUB_SHIP = attr('data-sub-ship', 'Later deliveries follow your schedule.');
  var U1 = attr('data-unit', 'Bottle'), UN = attr('data-units', 'Bottles');
  var KU1 = attr('data-kit-unit', 'Kit'), KUN = attr('data-kit-units', 'Kits');
  var KIT_HANDLE = attr('data-kit-handle', '');
  var KIT_DAYS = parseInt(attr('data-kit-days', '30'),10) || 30;
  var mode = 'once', kitOn = false, expanded = false;
  var QTY_MIN = 1, QTY_MAX = 10;
  var CUR = attr('data-cur', '$');
  var money = function(c){ return CUR + (c/100).toFixed(2); };
  var short = function(c){ var s=(c/100).toFixed(2); return CUR + (s.slice(-3)==='.00' ? s.slice(0,-3) : s); };
  var num = function(el,a){ return parseInt(el.getAttribute(a),10) || 0; };
  var D = '·';

  function selected(){ for (var i=0;i<rows.length;i++){ if(rows[i].classList.contains('selected')) return rows[i]; } return rows[0]; }
  function qty(){ var v=parseInt(qtyInput.value,10); if(isNaN(v)||v<QTY_MIN) v=QTY_MIN; if(v>QTY_MAX) v=QTY_MAX; return v; }
  function hasKit(r){ return !!r.getAttribute('data-kit-id'); }
  function k(r){ return kitOn && hasKit(r); }
  function available(r){
    if (kitOn && !hasKit(r)) return false;
    if (mode === 'once') return true;
    return num(r, k(r) ? 'data-kit-sub' : 'data-apex-sub') > 0;
  }
  function priceOf(r){
    if (mode === 'sub') return num(r, k(r) ? 'data-kit-sub' : 'data-apex-sub');
    return num(r, k(r) ? 'data-kit-price' : 'data-apex-price');
  }
  function fullOf(r){
    if (mode === 'sub') return num(r, k(r) ? 'data-kit-price' : 'data-apex-price');
    return num(r, k(r) ? 'data-kit-full' : 'data-full');
  }
  function kitSubOk(){ for (var i=0;i<rows.length;i++){ if(num(rows[i],'data-kit-sub')) return true; } return false; }
  function every(n){ return n === 1 ? 'every month' : (n === 12 ? 'every 12 months' : 'every ' + n + ' months'); }

  function layout(){
    var sel = selected();
    rows.forEach(function(r){
      var isExtra = r.classList.contains('tx-extra');
      var hide = !available(r) || (isExtra && !expanded && r !== sel);
      r.classList.toggle('tx-hidden', hide);
    });
    if (moreBtn){
      var extras = rows.filter(function(r){ return r.classList.contains('tx-extra') && available(r); });
      moreBtn.classList.toggle('tx-hidden', extras.length === 0);
      moreBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      moreBtn.querySelector('span').textContent = expanded ? 'Fewer options' : 'More options';
    }
  }

  function render(){
    if (kitBtn){
      var subBlocked = mode === 'sub' && !kitSubOk();
      kitBtn.disabled = subBlocked;
      if (subBlocked) kitOn = false;
    }
    var sel = selected(); if (!sel) return;
    if (!available(sel)){ var fb = rows.filter(available)[0]; if (fb){ rows.forEach(function(x){ x.classList.remove('selected'); }); fb.classList.add('selected'); sel = fb; } }
    rows.forEach(function(r){
      var n = num(r,'data-size');
      var days = num(r, k(r) ? 'data-kit-days' : 'data-days') || (n*30);
      var price = priceOf(r), full = fullOf(r);
      var save = full > price ? full - price : 0;
      var t = r.querySelector('.tx-row-title'), sub = r.querySelector('.tx-row-sub'), ship = r.querySelector('.tx-row-ship');
      var name = k(r) ? (n + ' ' + (n === 1 ? KU1 : KUN)) : (n + ' ' + (n === 1 ? U1 : UN));
      if (n === 12) name += ' ' + D + ' Annual supply';
      t.textContent = name;
      if (mode === 'sub'){
        sub.textContent = (n === 12 ? 'Delivered once a year' : 'Delivered ' + every(n)) + (save > 0 ? ' ' + D + ' Save ' + short(save) : '');
        if (SUB_FEE){ ship.textContent = price >= FREE_SUB ? 'Free shipping' : ('Shipping ' + SUB_FEE); ship.classList.remove('tx-hidden'); } else { ship.classList.add('tx-hidden'); }
      } else {
        sub.textContent = r.getAttribute(k(r) ? 'data-kit-line' : 'data-line') || (days + ' day supply');
        ship.classList.add('tx-hidden');
      }
      r.querySelector('[data-now]').textContent = money(price);
      r.querySelector('[data-perday]').textContent = money(price/days) + '/day';
      var strike = r.querySelector('[data-strike]');
      if (full > price){ strike.textContent = money(full); strike.style.display = ''; } else { strike.style.display = 'none'; }
      var banner = r.querySelector('.tx-row-banner');
      if (banner){
        var lead = n === 12 ? 'Best value' : 'Recommended';
        banner.textContent = save > 0 ? (lead + ' ' + D + ' Save ' + short(save)) : lead;
      }
    });
    layout();
    var unit = priceOf(sel), n = num(sel,'data-size');
    variantInput.value = k(sel) ? sel.getAttribute('data-kit-id') : sel.getAttribute('data-apex-id');
    planInput.value = mode === 'sub' ? (sel.getAttribute(k(sel) ? 'data-kit-plan' : 'data-plan') || '') : '';
    var total = money(unit*qty());
    atc.textContent = (mode === 'sub' ? 'Subscribe ' : CTA + ' ') + D + ' ' + total;
    if (stickyCta) stickyCta.textContent = (mode === 'sub' ? 'Subscribe ' : CTA + ' ') + D + ' ' + total;
    if (stickyTitle) stickyTitle.textContent = (k(sel) ? KIT_NAME : NAME) + (mode === 'sub' ? ' ' + D + ' Subscribe' : '');
    if (stickySize){
      Array.prototype.forEach.call(stickySize.options, function(o){ var r = rows.filter(function(x){ return x.getAttribute('data-size') === o.value; })[0]; o.disabled = !r || !available(r); });
      stickySize.value = sel.getAttribute('data-size');
    }
    if (billLine) billLine.textContent = mode === 'sub' ? ('Charged ' + total + ' today, then ' + money(unit*qty()) + ' ' + every(n) + '. Pause or cancel anytime.') : '100% money-back guarantee';
    if (shipLine) shipLine.textContent = mode === 'sub' ? SUB_SHIP : shipBase;
    if (kitBtn && kitPrice){
      kitBtn.classList.toggle('on', kitOn);
      kitBtn.setAttribute('aria-pressed', kitOn ? 'true' : 'false');
      if (kitBtn.disabled){ kitPrice.textContent = 'Available as a one-time purchase'; }
      else if (!hasKit(sel)){ kitPrice.textContent = 'Not available for this pack size'; }
      else {
        var baseP = num(sel, mode === 'sub' ? 'data-apex-sub' : 'data-apex-price');
        var kitP = num(sel, mode === 'sub' ? 'data-kit-sub' : 'data-kit-price');
        kitPrice.textContent = (kitOn ? 'Added' : '+' + money(kitP - baseP)) + (mode === 'sub' ? ' ' + D + ' per delivery' : '');
      }
    }
  }

  function selectSize(size){
    rows.forEach(function(x){ x.classList.toggle('selected', x.getAttribute('data-size') === String(size)); });
    render();
  }
  rows.forEach(function(r){ r.addEventListener('click', function(){ selectSize(r.getAttribute('data-size')); }); });
  if (moreBtn) moreBtn.addEventListener('click', function(){ expanded = !expanded; layout(); });
  if (kitBtn) kitBtn.addEventListener('click', function(){ if (kitBtn.disabled) return; kitOn = !kitOn; render(); });

  function setMode(m){
    mode = m;
    modeBtns.forEach(function(b){ var on = b.getAttribute('data-mode') === m; b.classList.toggle('active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    render();
  }
  modeBtns.forEach(function(b){ b.addEventListener('click', function(){ setMode(b.getAttribute('data-mode')); }); });

  document.getElementById('tx-qty-minus').addEventListener('click', function(){ qtyInput.value = Math.max(QTY_MIN, qty()-1); render(); });
  document.getElementById('tx-qty-plus').addEventListener('click', function(){ qtyInput.value = Math.min(QTY_MAX, qty()+1); render(); });
  qtyInput.addEventListener('change', function(){ qtyInput.value = qty(); render(); });
  qtyInput.addEventListener('input', render);

  function scrollToBuy(){ form.scrollIntoView({behavior:'smooth', block:'center'}); }
  Array.prototype.forEach.call(root.querySelectorAll('[data-pick-size]'), function(btn){
    btn.addEventListener('click', function(){
      var size = btn.getAttribute('data-pick-size');
      var m = btn.getAttribute('data-pick-mode');
      var kit = btn.getAttribute('data-pick-kit');
      if (kit !== null && kitBtn && !kitBtn.disabled) kitOn = kit === '1';
      if (m) setMode(m);
      if (rows.some(function(x){ return x.getAttribute('data-size') === size; })) selectSize(size); else render();
      scrollToBuy();
    });
  });
  var finalCta = document.getElementById('tx-final-cta');
  if (finalCta) finalCta.addEventListener('click', scrollToBuy);
  if (stickySize) stickySize.addEventListener('change', function(){ selectSize(stickySize.value); });
  if (stickyCta) stickyCta.addEventListener('click', function(){ if (form.requestSubmit) form.requestSubmit(); else atc.click(); });

  function addToCart(item, btn){
    btn.disabled = true;
    return fetch('/cart/add.js', { method:'POST', body: JSON.stringify({ items: [item] }), headers: {'Content-Type':'application/json','Accept':'application/json'} })
      .then(function(r){ return r.json(); })
      .then(function(data){
        btn.disabled = false;
        if (data.status){ alert('Could not add to cart: ' + (data.description || data.message || 'please try again.')); return; }
        if (window.Shopify && typeof window.Shopify.onItemAdded === 'function'){ window.Shopify.onItemAdded(data, true); }
        else { window.location.href = '/cart'; }
      });
  }
  form.addEventListener('submit', function(e){
    e.preventDefault();
    var main = { id: parseInt(variantInput.value,10), quantity: qty() };
    if (planInput.value) main.selling_plan = parseInt(planInput.value,10);
    addToCart(main, atc).catch(function(err){ atc.disabled = false; console.error('add to cart failed', err); if (!planInput.value) { planInput.disabled = true; } form.submit(); });
  });

  if (stickyBar && 'IntersectionObserver' in window){
    var shown = false;
    new IntersectionObserver(function(entries){
      var e = entries[0];
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      if (past !== shown){
        shown = past;
        stickyBar.classList.toggle('show', past);
        stickyBar.setAttribute('aria-hidden', past ? 'false' : 'true');
        stickyCta.tabIndex = past ? 0 : -1;
        if (stickySize) stickySize.tabIndex = past ? 0 : -1;
      }
    }).observe(atc);
  }

  var main = document.getElementById('tx-car-main');
  var wrap = document.getElementById('tx-car-wrap');
  var thumbs = root.querySelectorAll('.tx-car-thumb');
  var dots = root.querySelectorAll('#tx-car-dots i');
  function cur(){ for (var i=0;i<thumbs.length;i++){ if(thumbs[i].classList.contains('active')) return i; } return 0; }
  function show(i){
    if (!thumbs.length) return;
    if (i<0) i=thumbs.length-1; if (i>=thumbs.length) i=0;
    thumbs.forEach(function(t,j){ t.classList.toggle('active', j===i); });
    dots.forEach(function(d,j){ d.classList.toggle('on', j===i); });
    main.src = thumbs[i].getAttribute('data-src');
  }
  thumbs.forEach(function(t,i){ t.addEventListener('click', function(){ show(i); }); });
  var prev = document.getElementById('tx-car-prev'), next = document.getElementById('tx-car-next');
  if (prev) prev.addEventListener('click', function(){ show(cur()-1); });
  if (next) next.addEventListener('click', function(){ show(cur()+1); });
  if (wrap){
    var sx = null;
    wrap.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; }, {passive:true});
    wrap.addEventListener('touchend', function(e){ if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(cur() + (dx < 0 ? 1 : -1)); sx = null; });
  }

  setMode('once');

  /* ---------- Kit data (optional): live kit prices and Loop plans for the switch and the #tx-kit panel ---------- */
  if (!KIT_HANDLE) return;
  var kitSec = document.getElementById('tx-kit');
  function packSize(title){ var m = String(title).match(/(\d+)/); var n = m ? parseInt(m[1],10) : 0; if (/12 Kits/.test(title)) n = 12; return n; }
  function esc(t){ return String(t).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  var PLAN_BY_SIZE = {};
  rows.forEach(function(r){ var p = num(r,'data-plan'); if (p) PLAN_BY_SIZE[num(r,'data-size')] = p; });

  fetch('/products/' + KIT_HANDLE + '.js', { headers: { 'Accept': 'application/json' } })
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(kp){
      if (!kp || !kp.variants) return;
      var kits = [];
      kp.variants.forEach(function(v){
        if (!v.available) return;
        var n = packSize(v.title); if (!n) return;
        var plan = PLAN_BY_SIZE[n] || 0, sub = 0;
        (v.selling_plan_allocations || []).forEach(function(a){ if (a.selling_plan_id === plan) sub = a.price; });
        if (!sub) plan = 0;
        kits.push({ id: v.id, n: n, price: v.price, sub: sub, plan: plan });
      });
      if (!kits.length) return;

      rows.forEach(function(r){
        var kv = kits.filter(function(x){ return String(x.id) === r.getAttribute('data-kit-id'); })[0];
        if (kv && kv.plan){ r.setAttribute('data-kit-sub', kv.sub); r.setAttribute('data-kit-plan', kv.plan); }
      });
      render();

      if (!kitSec) return;
      var oldPrices = kitSec.querySelector('.tx-stack-prices');
      var oldBtn = kitSec.querySelector('[data-pick-kit="1"]');
      if (!oldPrices) return;
      var hasSub = kits.some(function(x){ return x.sub > 0; });
      var opts = kits.map(function(x, i){
        return '<option value="' + x.id + '"' + (i === 0 ? ' selected' : '') + '>' + x.n + ' ' + (x.n === 1 ? KU1 : KUN) + ' ' + D + ' ' + (x.n*2) + ' bottles' + (x.n === 12 ? ' ' + D + ' Annual supply' : '') + '</option>';
      }).join('');
      var wrapK = document.createElement('div');
      wrapK.className = 'tx-kitbuy';
      wrapK.innerHTML =
        '<label class="tx-label" for="tx-kit-size">Choose your kit</label>' +
        '<div class="tx-kit-select"><select id="tx-kit-size">' + opts + '</select></div>' +
        (hasSub ? '<div class="tx-mode tx-kit-mode" role="group" aria-label="Kit purchase type">' +
          '<button type="button" class="active" data-kmode="once" aria-pressed="true">One-time<small>Single order</small></button>' +
          '<button type="button" data-kmode="sub" aria-pressed="false">Subscribe<small>Delivered on schedule</small></button></div>' : '') +
        '<div class="tx-kit-price"><small id="tx-kit-meta"></small><strong id="tx-kit-now"></strong></div>' +
        '<div class="tx-atc-row"><div class="tx-qty">' +
          '<button type="button" id="tx-kit-minus" aria-label="Decrease kit quantity">&minus;</button>' +
          '<input type="number" id="tx-kit-qty" value="1" min="1" max="10" inputmode="numeric" aria-label="Kit quantity">' +
          '<button type="button" id="tx-kit-plus" aria-label="Increase kit quantity">&#43;</button></div>' +
          '<button type="button" class="tx-atc" id="tx-kit-atc">' + esc(CTA) + '</button></div>' +
        '<p class="tx-kit-bill" id="tx-kit-bill"></p>';
      oldPrices.parentNode.replaceChild(wrapK, oldPrices);
      if (oldBtn) oldBtn.parentNode.removeChild(oldBtn);

      var kSel = document.getElementById('tx-kit-size'), kNow = document.getElementById('tx-kit-now');
      var kMeta = document.getElementById('tx-kit-meta'), kAtc = document.getElementById('tx-kit-atc');
      var kQty = document.getElementById('tx-kit-qty'), kBill = document.getElementById('tx-kit-bill');
      var kModeBtns = wrapK.querySelectorAll('[data-kmode]');
      var kMode = 'once', kBase = shipBase || 'Ships within 1 to 2 business days.';
      function kq(){ var v = parseInt(kQty.value,10); if (isNaN(v) || v < 1) v = 1; if (v > 10) v = 10; return v; }
      function kCur(){ return kits[kSel.selectedIndex] || kits[0]; }
      function kRender(){
        Array.prototype.forEach.call(kSel.options, function(o, i){ o.disabled = kMode === 'sub' && !kits[i].sub; });
        if (kSel.options[kSel.selectedIndex].disabled){ for (var i=0;i<kits.length;i++){ if (kits[i].sub){ kSel.selectedIndex = i; break; } } }
        var x = kCur(), unit = kMode === 'sub' ? x.sub : x.price, total = money(unit*kq());
        kNow.textContent = money(unit);
        kMeta.textContent = x.n + ' ' + (x.n === 1 ? KU1 : KUN) + ' ' + D + ' ' + (kMode === 'sub' ? (x.n === 12 ? 'Delivered once a year' : 'Delivered ' + every(x.n)) : (x.n*2) + ' bottles');
        kAtc.textContent = (kMode === 'sub' ? 'Subscribe ' : CTA + ' ') + D + ' ' + total;
        kBill.textContent = kMode === 'sub' ? ('Charged ' + total + ' today, then ' + every(x.n) + '. Pause or cancel anytime.') : kBase;
        kModeBtns.forEach(function(b){ var on = b.getAttribute('data-kmode') === kMode; b.classList.toggle('active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      }
      kModeBtns.forEach(function(b){ b.addEventListener('click', function(){ kMode = b.getAttribute('data-kmode'); kRender(); }); });
      kSel.addEventListener('change', kRender);
      document.getElementById('tx-kit-minus').addEventListener('click', function(){ kQty.value = Math.max(1, kq()-1); kRender(); });
      document.getElementById('tx-kit-plus').addEventListener('click', function(){ kQty.value = Math.min(10, kq()+1); kRender(); });
      kQty.addEventListener('change', function(){ kQty.value = kq(); kRender(); });
      kQty.addEventListener('input', kRender);
      kAtc.addEventListener('click', function(){
        var x = kCur(), item = { id: x.id, quantity: kq() };
        if (kMode === 'sub' && x.plan) item.selling_plan = x.plan;
        addToCart(item, kAtc).catch(function(err){ kAtc.disabled = false; console.error('kit add to cart failed', err); });
      });
      kRender();
    })
    .catch(function(err){ console.error('kit data failed', err); });
})();
